import { HalfContainer } from "common/common.styled";
import Button from "components/Button";
import { DurationPicker } from "components/DurationPicker/DurationPicker";
import { Grid } from "components/Grid/Grid";
import SingleSelect from "components/SingleSelect";
import Text from "components/Text";
import TextInput from "components/TextInput";
import { ethnicityOptions } from "pages/Profile/EditProfile/PhysicalDetails/constants";
import { FC } from "react";
import { BsArrowLeft, BsArrowRight } from "react-icons/bs";
import theme from "theme";
import { colors } from "theme/colors";
import { JobPurposeWrapper } from "../JobPurpose/JobPurpose.styled";
import { JobDetailsWrapper } from "./JobDetails.styled";
import SuggestiveTextInput from "./SuggestiveTextInput";
import { useJobDetails } from "./useJobDetails";

export const JobDetails: FC = () => {
    const {
        agencyName,
        purposeName,
        location,
        handleJobInfoChange,
        jobInfo,
        jobInfoErrors,
        durations,
        handleDurationChange,
        dropdownInputs,
        dropdownInputsErrors,
        handleDropdownChange,
        languageData,
        handleBack,
        handleNext,
        startDate,
        endDate,
        handleJobDetailsStartDateChange,
        handleJobDetailsEndDateChange,
    } = useJobDetails();
    return (
        <JobPurposeWrapper>
            <HalfContainer>
                <Text variant="body3" color={theme.colors.grey.primary}>
                    I am posting a job on behalf of{" "}
                    <Text
                        variant="body3"
                        color={theme.colors.grey.dark}
                        fontWeight="600"
                    >
                        {agencyName}
                    </Text>{" "}
                    for a{" "}
                    <Text
                        variant="body3"
                        color={theme.colors.grey.dark}
                        fontWeight="600"
                    >
                        {purposeName}{" "}
                    </Text>
                    in{" "}
                    <Text
                        variant="body3"
                        color={theme.colors.grey.dark}
                        fontWeight="600"
                    >
                        {location}
                    </Text>
                </Text>
                <JobDetailsWrapper>
                    <Text variant="button1">Fill the necessary details</Text>
                    <TextInput
                        label="Title"
                        placeholder="Eg. McDonald's commercial, Thriller feature film, etc."
                        required
                        tabIndex={1}
                        minWidth="40rem"
                        value={jobInfo.title}
                        name="title"
                        errorMsg={jobInfoErrors.title}
                        onChange={handleJobInfoChange}
                    />
                    <TextInput
                        multiLine
                        label="Description"
                        placeholder="Write Something"
                        minWidth="40rem"
                        tabIndex={2}
                        value={jobInfo.description}
                        name="description"
                        errorMsg={jobInfoErrors.description}
                        onChange={handleJobInfoChange}
                    />
                    <Grid row={true} columnGap={1} expanded>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: "8px",
                                color: colors.grey.primary,
                                fontSize: "12px",
                                fontWeight: "600",
                                fontFamily: `"Montserrat", sans-serif`,
                            }}
                        >
                            <label>Start Date</label>
                            <input
                                type="date"
                                style={{
                                    color: colors.text,
                                    padding: "0.50rem",
                                    border: "0px ",
                                    backgroundColor: colors.background,
                                    borderRadius: "10px",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                    fontFamily: `"Montserrat", sans-serif`,
                                }}
                                tabIndex={3}
                                value={startDate || ""}
                                onChange={handleJobDetailsStartDateChange}
                            />
                        </div>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: "8px",
                                color: colors.grey.primary,
                                fontSize: "12px",
                                fontWeight: "600",
                                fontFamily: `"Montserrat", sans-serif`,
                            }}
                        >
                            <label>End Date</label>
                            <input
                                type="date"
                                style={{
                                    color: colors.text,
                                    padding: "0.50rem",
                                    border: "0px ",
                                    backgroundColor: colors.background,
                                    borderRadius: "10px",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                    fontFamily: `"Montserrat", sans-serif`,
                                }}
                                min={startDate}
                                tabIndex={4}
                                value={endDate || ""} // Use default value if undefined
                                onChange={handleJobDetailsEndDateChange} // Updated
                            />
                        </div>
                    </Grid>
                    <Grid row={true} columnGap={1} expanded>
                        <DurationPicker
                            label="Experience"
                            value={durations.experience}
                            tabIndex={5}
                            handleDurationChange={(value) => {
                                handleDurationChange("experience", value);
                            }}
                        />
                        <DurationPicker
                            label="Duration"
                            value={durations.duration}
                            tabIndex={6}
                            handleDurationChange={(value) =>
                                handleDurationChange("duration", value)
                            }
                        />
                    </Grid>
                    <Grid row={true} columnGap={1} expanded>
                        <DurationPicker
                            label="Age(min)"
                            value={durations.minAge}
                            disableUnit
                            tabIndex={7}
                            handleDurationChange={(value) =>
                                handleDurationChange("minAge", value)
                            }
                        />
                        <DurationPicker
                            label="Age(max)"
                            value={durations.maxAge}
                            disableUnit
                            tabIndex={8}
                            handleDurationChange={(value) =>
                                handleDurationChange("maxAge", value)
                            }
                        />
                    </Grid>
                    <Grid row={true} columnGap={1} expanded>
                        <SingleSelect
                            options={[
                                { label: "Male", value: "male" },
                                { label: "Female", value: "female" },
                                { label: "Other", value: "other" },
                            ]}
                            label="Gender"
                            required
                            tabIndex={9}
                            minWidth="11.5rem"
                            placeholder="Select Gender"
                            value={dropdownInputs.gender}
                            onChange={(value) =>
                                handleDropdownChange("gender", value)
                            }
                            errorText={dropdownInputsErrors.gender}
                        />
                        <TextInput
                            type="number"
                            label="No. of vacancies"
                            required
                            minWidth="11.5rem"
                            placeholder="3"
                            tabIndex={10}
                            name="numberOfSeats"
                            value={jobInfo.numberOfSeats}
                            onChange={handleJobInfoChange}
                            errorMsg={jobInfoErrors.numberOfSeats}
                        />
                    </Grid>

                    <Grid row={true} columnGap={1} expanded>
                        <SuggestiveTextInput // Use the new suggestive text input component
                            options={languageData}
                            label="Language"
                            minWidth="15rem"
                            required
                            placeholder="Select Language"
                            value={dropdownInputs?.language_id || ""}
                            errorText={dropdownInputsErrors.language_id}
                            onChange={(value) =>
                                handleDropdownChange("language_id", value)
                            }
                        />
                        <SuggestiveTextInput
                            options={ethnicityOptions}
                            label="Ethnicity"
                            minWidth="10rem"
                            required
                            placeholder="Select Ethnicity"
                            value={dropdownInputs?.ethnicity || ""}
                            onChange={(value) =>
                                handleDropdownChange("ethnicity", value)
                            }
                            errorText={dropdownInputsErrors.ethnicity}
                        />
                    </Grid>

                    <Grid marginTop={3} marginBottom={2} columnGap={1}>
                        <Button
                            type="button"
                            variant="outlined"
                            icon={<BsArrowLeft />}
                            iconPosition="prefix"
                            onClick={handleBack}
                        >
                            Back
                        </Button>
                        <Button
                            type="button"
                            variant="filled"
                            icon={<BsArrowRight />}
                            iconPosition="suffix"
                            onClick={handleNext}
                        >
                            Next
                        </Button>
                    </Grid>
                </JobDetailsWrapper>
            </HalfContainer>
        </JobPurposeWrapper>
    );
};
